export const Flex = {}

export default Flex
